export const VALIDATORS = {
  REQUIRED: (value: string): boolean | string => {
    return (!!value && !!value.trim()) || "Field is required.";
  },
  DEFINED: (value: string): boolean | string => {
    return value !== undefined || "Field is required.";
  },
  REQUIRED_CHECKBOX: (value: boolean): boolean | string => {
    return !value || value || "Field is required.";
  },
  REQUIRED_COMPANY_NAME: (value: string): boolean | string => {
    return (!!value && !!value.trim()) || "Company name is required.";
  },
  REQUIRED_CODE: (value: string): boolean | string => {
    return (!!value && !!value.trim()) || "Code is required.";
  },
  REQUIRED_ACCOUNT: (value: string): boolean | string => {
    return (!!value && !!Number(value)) || "Account is required.";
  },
  REQUIRED_ACCOUNTS: (value: string): boolean | string => {
    return (!!value && !!value.length) || "Accounts is required.";
  },
  EXCLUDE_PIPE: (value: string): boolean | string => {
    return value.indexOf("|") < 0 || "Pipe symbol is prohibited.";
  },
  REQUIRED_PASSWORD: (value: string): boolean | string => {
    if (!value) {
      return "Password is required.";
    }

    if (value.length < 8) {
      return "Password must be at least 8 characters";
    }

    if (!/[a-z]/.test(value)) {
      return "Password must have at least 1 lower case character";
    }

    if (!/.*[A-Z].*/.test(value)) {
      return "Password must have at least 1 upper case character";
    }

    if (!/.*[0-9].*/.test(value)) {
      return "Password must have at least 1 numerical character";
    }

    if (!/.*[^a-zA-Z0-9].*/.test(value)) {
      return "Password must have at least 1 symbol";
    }

    return true;
  },
  REQUIRED_PASSWORD_LOGIN: (value: string): boolean | string => !!value || "Password is required.",
  REQUIRED_PASSWORD_CONFIRMATION: (value: string): boolean | string => !!value || "Password confirmation is required.",
  REQUIRED_EMAIL: (value: string): boolean | string => {
    if (!value) {
      return "E-mail is required.";
    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.toLowerCase()) || "Must be valid email address.";
  },
  MIN_LENGTH:
    (min: number) =>
    (value: string): boolean | string => {
      if (typeof value !== "string" || !value.trim()) {
        return `Must be at least ${min} characters.`;
      }
      return value.length >= min || `Must be at least ${min} characters.`;
    },
  UNIQUE:
    (
      list: string[],
      exclude?: string | string[] | (() => string) | (() => string[]),
      message = "Name must be unique"
    ) =>
    (value: string): boolean | string => {
      if (!value) return true;

      const norm = (s: unknown) => (typeof s === "string" ? s.trim().toLowerCase() : "");

      const normalized = new Set(list.map(norm));

      let excludes: string[] = [];
      if (typeof exclude === "function") {
        const res = exclude();
        excludes = Array.isArray(res) ? res : [res];
      } else if (exclude != null) {
        excludes = Array.isArray(exclude) ? exclude : [exclude];
      }
      excludes.map(norm).forEach((e) => {
        if (e) normalized.delete(e);
      });

      const val = norm(value);
      return !normalized.has(val) || message;
    },
  VALID_URL: (value: string): boolean | string => {
    if (!value) {
      return true;
    }

    try {
      const url = new URL(value);
      return ["https:"].includes(url.protocol) || "Must be a valid https:// URL.";
    } catch (_) {
      return "Must be a valid https:// URL.";
    }
  },
  MAX_VALUE:
    (max: number) =>
    (value: string): boolean | string => {
      if (!value) return true;

      const cleaned = value.replace(/[^0-9.]/g, "");
      const number = parseFloat(cleaned);

      if (isNaN(number)) {
        return "Value must be a number.";
      }

      return number <= max || `Value must be less than or equal to ${max}.`;
    },
};
